import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser, UserRole } from '../data/session';

interface RouteGuardProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ allowedRoles, children }) => {
  const role = getCurrentUser().role;
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
};

export default RouteGuard;
